import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Introduzir soluções de segurança avançadas para transações bancárias online.",
    correct: false,
  },
  {
    option:
      "b) Fornecer uma abordagem personalizada, permitindo que os clientes interajam via chatbots, assistentes de voz e agentes humanos.",
    correct: true,
  },
  {
    option:
      "c) Priorizar a automação completa dos serviços bancários, eliminando a necessidade de interações humanas.",
    correct: false,
  },
  {
    option:
      "d) Concentrar-se na criação de agências bancárias físicas para fortalecer o atendimento presencial.",
    correct: false,
  },
  {
    option:
      "e) Popularizar o uso de aplicativos de mensagens no mercado nacional e internacional.",
    correct: false,
  },
];

export default function Question22(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question22: {
          title:
            "Qual é a principal proposta da Topaz na revolução do atendimento bancário digital por meio do conversational banking?",
          option: option.option,
          correct: option.correct,
          order: 22
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Qual é a principal proposta da Topaz na revolução do atendimento bancário digital por meio do conversational banking?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
